import { render, staticRenderFns } from "./AdminSubzonesTable.vue?vue&type=template&id=244569b4&"
import script from "./AdminSubzonesTable.vue?vue&type=script&lang=js&"
export * from "./AdminSubzonesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports